import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'xp-review',
	standalone: true,
	templateUrl: './xp-review.component.html',
	styleUrls: ['./xp-review.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpReviewComponent {
	score = input('');
	date = input('');
	text = input('');
}
